import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import {fetchCommentFeed, updateCommentFeed, updateLikeComment, fetchLikeComment} from "../../../actions/feedAction";
import {fetchCommentMedia, updateCommentMedia, updateLikeMediaComment, fetchLikeMediaComment} from "../../../actions/mediaAction";
import iconPath from "./../../../helpers/iconHelper";
import CommentLikeModal from "./CommentLikeModal";
import { getlanguagelist } from "../../../helpers/changelanguage";
import "./FeedFooterCommentDetails.css"



class FeedFooterCommentDetails extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      commentList         : [],
      user_child_comment  : '',
      user_comment        : '',
      showComment         : 'none',
      openfeed            : 0,
      currentfeed         : this.props.feed_id,
      openPopup           : this.openPopup,
      commentreactionList : {},
      modal_open_comment  : false,
      open_comment_reply  : ''
    };
    this.fetchCommentFeed       = this.fetchCommentFeed.bind(this);
    this.makeComment            = this.makeComment.bind(this);
    this.handleChange           = this.handleChange.bind(this);
    this.updateLikeCommentList  = this.updateLikeCommentList.bind(this);
    this.handleCloseComment     = this.handleCloseComment.bind(this);
    this.fetchLikeCommentList   = this.fetchLikeCommentList.bind(this);
    this.openCommentReply       = this.openCommentReply.bind(this);

  }

  componentDidMount(){
   
    if(this.props.position != 'feed'){
      this.fetchCommentFeed(this.props.feed_id,this.props.data_type);
      this.setState({
        showComment : 'block'
      })
    }
  }

  fetchCommentFeed(feedId,dataType){
   
    if((dataType == 'POST') || (dataType == 'ALBUM') || (dataType == 'Promotion') || (dataType == 'POLL') || (dataType == 'GAME POST')){
      const param = {
        feed_id     : feedId,
        return_type : 'COMMENT',
        flag        : (dataType == 'Promotion') ? 'Promotion' : ''
      }
      this.props.fetchCommentFeed(param);
      this.setState({
        modal_open : true
      });
    }else if(dataType == 'GALLERY IMAGE'){
      const param = {
        image_id    : feedId,
        return_type : 'COMMENT'
      }
      this.props.fetchCommentMedia(param);
      this.setState({
        modal_open : true
      });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps,prevProps) {
    
    if(nextProps.updatecommentlikelist != this.props.updatecommentlikelist){
      
      if(nextProps.updatecommentlikelist.section == 'PARENT'){
        /*fetched liked post response*/
        let matchedIndex = (nextProps.commentList.comment_details).map(function (obj) { 
          return obj.id; 
        }).indexOf(nextProps.updatecommentlikelist.comment_id);
        if(matchedIndex >= 0){
          nextProps.commentList.comment_details[matchedIndex].my_reaction    =  nextProps.updatecommentlikelist.my_reaction;
          nextProps.commentList.comment_details[matchedIndex].total_reaction =  nextProps.updatecommentlikelist.total_reaction;
          this.setState({
            commentList : nextProps.commentList.comment_details,
          });
        }
      }else{
        let matchedIndex = (nextProps.commentList.comment_details).map(function (obj) { 
          return obj.id; 
        }).indexOf(nextProps.updatecommentlikelist.section);
        if(matchedIndex >= 0){
          let matchedIndex2 = (nextProps.commentList.comment_details[matchedIndex].childrow).map(function (obj) { 
            return obj.id; 
          }).indexOf(nextProps.updatecommentlikelist.comment_id);
          if(matchedIndex2 >= 0){
            nextProps.commentList.comment_details[matchedIndex].childrow[matchedIndex2].my_reaction    =  nextProps.updatecommentlikelist.my_reaction;
            nextProps.commentList.comment_details[matchedIndex].childrow[matchedIndex2].total_reaction =  nextProps.updatecommentlikelist.total_reaction;
            this.setState({
              commentList : nextProps.commentList.comment_details,
            });
          }
        }
      }
      
    }

    if(nextProps.commentlikelist != this.props.commentlikelist){
      this.setState({
        commentreactionList : nextProps.commentlikelist,
      });
    }
    
    if(nextProps.updateComment != this.props.updateComment){
      this.fetchCommentFeed(this.props.feed_id,this.props.data_type);
      this.setState({
        user_child_comment : '',
        user_comment : '',
      });
    }
    if(nextProps.commentList != this.props.commentList){
      this.setState({
        commentList : nextProps.commentList.comment_details,
      });
    }

    /* if((nextProps.updatelikelist != prevProps.updatelikelist) && (Object.keys(nextProps.updatelikelist).length > 0)){
      this.setState({
        changemyReaction    : (nextProps.updatelikelist.my_reaction != '') ? nextProps.updatelikelist.my_reaction : 'DEFAULTREACTION',
        changetotalReaction : nextProps.updatelikelist.total_reaction,
        changefeedId        : nextProps.updatelikelist.feed_id

      });
    } */
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  makeComment(commentType,contentId,parrentComid = null){
    if(this.props.position == 'post'){
      let params = {
        comment_type     : commentType,
        content_id       : contentId,
        parent_comment_id: parrentComid,
        image            : null,
        image_type       : null,
        comment          : (parrentComid != null) ? this.state.user_child_comment : this.state.user_comment
      }
      if(params.comment == ''){
        ToastsStore.error('Message cannot be blank')
      }else{
        this.props.updateCommentFeed(params);
      }
    }else if(this.props.position == 'media'){
      let params = {
        image_id         : contentId,
        parent_comment_id: parrentComid,
        image            : null,
        image_type       : null,
        comment          : (parrentComid != null) ? this.state.user_child_comment : this.state.user_comment
      }
      if(params.comment == ''){
        ToastsStore.error('Message cannot be blank')
      }else{
        this.props.updateCommentMedia(params);
      }
    }
    
    //console.log(params);
    // console.log(commentType,contentId,parrentComid);
    
    
  } 

  openPopup(feedId,current_my_reaction){
    window.$('#comment_element_'+feedId).toolbar({
      content   : '#comment_toolbar_options_'+feedId,
      position  : 'top',
      style     : 'primary',
      animation : 'bounce',
    });

    let self = this;
    window.$('#comment_element_'+feedId).off('toolbarItemClick');
    window.$('#comment_element_'+feedId).on('toolbarItemClick',
    function( event,buttonClicked ) {
    
        let res = (buttonClicked.id).split("_");
        self.updateLikeCommentList(res[1],res[2],res[3],res[0],current_my_reaction);
    });
  }

  updateLikeCommentList(feed_id,reaction,comment_id,section,current_my_reaction){
   
    let param = null;
    if(this.props.data_type == 'Promotion'){
      param = {
        promotion_id    : feed_id,
        reaction        : (current_my_reaction == reaction) ? `UN_${reaction}` : reaction,
        comment_id      : comment_id,
        section         : section,
        data_type       : this.props.data_type
      };
    }else{
      param = {
        feed_id    : feed_id,
        reaction   : (current_my_reaction == reaction) ? `UN_${reaction}` : reaction,
        comment_id : comment_id,
        section    : section,
        data_type  : this.props.data_type
      };
    }
    
    if(this.props.position == 'post'){
      this.props.updateLikeComment(param);
    }else if(this.props.position == 'media'){
      this.props.updateLikeMediaComment(param);
    }

  }
  handleCloseComment(){
    this.setState({
      modal_open_comment : false
    });
  };
  fetchLikeCommentList(commentId,dataType){
    if((dataType == 'POST') || (dataType == 'ALBUM') || (dataType == 'Promotion')|| (dataType == 'POLL')){
      const param = {
        comment_id     : commentId,
        flag           : dataType
      }
      this.props.fetchLikeComment(param);
      this.setState({
        modal_open_comment : true
      });
    }else if(dataType == 'GALLERY IMAGE'){
      const param = {
        comment_id     : commentId
      }
      this.props.fetchLikeMediaComment(param);
      this.setState({
        modal_open_comment : true
      });
    }
  }
  openCommentReply(commentId){
    if(this.state.open_comment_reply == commentId){
      this.setState({
        open_comment_reply : '',
      })
    }else{
      this.setState({
        open_comment_reply : commentId,
      })
    }
    
  }
  render() {
    let  languagelist = getlanguagelist();
       return (    
        <div className="post_comment_area" style={{display: this.state.showComment}}> 
                {/*  <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} lightBackground /> */}
        <ul>
        {   
            (this.state.commentList.length > 0) ? 
            (this.state.commentList).map((comment,index) => {
              return (
                  <li key={index}>
                    <div className="post_cmnt_header">
                        <div className="list_ico">
                        
                          {
                              (comment.media_link != '') ? 
                              <img src={comment.media_link} onError = {(e) => {
                                e.target.src = iconPath['DEFAULTUSER']
                              }}/> : 
                              <img src={iconPath['DEFAULTUSER']}/>
                          }
                        </div>
                        <div className="list_details">
                            <h4>{comment.full_name}</h4>
                            <span className="comment_time">{comment.post_date}</span>
                            <div className="clr10"></div>
                            <div className="post_comment">
                                {
                                  (comment.image != '') ?
                                    <img src={comment.image} className="commet-img"/>
                                  : null
                                }
                                
                                <p>{comment.comment}</p>
                                <div className="clearfix"></div>
                            </div>
                            <div className="post_comment_footer">
                                <div id={`comment_toolbar_options_${comment.id}`} className="hidden" >
                                  <a href="#" id={`PARENT_${this.props.feed_id}_LIKE_${comment.id}`} ><img src={iconPath['LIKE']} /></a>
                                  <a href="#" id={`PARENT_${this.props.feed_id}_DISLIKE_${comment.id}`} ><img src={iconPath['DISLIKE']} /></a>
                                  <a href="#" id={`PARENT_${this.props.feed_id}_LAUGH_${comment.id}`} ><img src={iconPath['LAUGH']} /></a>
                                  <a href="#" id={`PARENT_${this.props.feed_id}_ANGRY_${comment.id}`} ><img src={iconPath['ANGRY']} /></a>
                                  <a href="#" id={`PARENT_${this.props.feed_id}_LOVE_${comment.id}`} ><img src={iconPath['LOVE']} /></a>
                                  <a href="#" id={`PARENT_${this.props.feed_id}_SAD_${comment.id}`} ><img src={iconPath['SAD']} /></a>
                                  <a href="#" id={`PARENT_${this.props.feed_id}_BREAK HEART_${comment.id}`} ><img src={iconPath['BREAKHEART']} /></a>
                                  <div className="clearfix"></div>
                                </div>
                                <div className="lile_count btn-toolbar" id={`comment_element_${comment.id}`} onMouseEnter={() => this.openPopup(comment.id,comment.my_reaction)}>
                                  <p>{/* {languagelist.like} */}
                                      <img width="35px" src= {(comment.my_reaction == '') ? "/assets/images/like_dislike_goldspace.png" : iconPath[comment.my_reaction]}></img> 
                                  </p>
                                </div>
                                {(comment.total_reaction > 0) ?
                                  <div className="like_icons">
                                    <a href={void(0)} onClick={()=>this.fetchLikeCommentList(comment.id,this.props.data_type)}>{comment.total_reaction}</a>
                                  </div> 
                                  : null
                                }
                                <CommentLikeModal key={comment.id} handleClose={this.handleCloseComment} modalOpen={this.state.modal_open_comment} reactionList={this.state.commentreactionList}/>
                                <div className="commtent_reply"><a href={void(0)} onClick={()=>this.openCommentReply(comment.id)}>{languagelist.reply}</a></div>
                               {/*  <div className="commtent_more"><a href="#">More Replies <i className="fa fa-angle-double-right"></i></a></div> */}

                            </div>
                            <div className="clr20"></div>
                            {   
                              (comment.childrow.length > 0) ? 
                                (comment.childrow).map((childcomment,index) => {
                                  return(
                                    <div className="post_cmnt_header" key={index}>
                                    <div className="list_ico">
                                    {
                                        (childcomment.media_link != '') ? 
                                        <img src={childcomment.media_link} onError = {(e) => {
                                          e.target.src = iconPath['DEFAULTUSER']
                                        }}/> : 
                                        <img src={iconPath['DEFAULTUSER']}/>
                                    }
                                    </div>
                                    <div className="list_details">
                                        <h4>{childcomment.full_name}</h4>
                                        <span className="comment_time">{childcomment.post_date}</span>
                                        <div className="clr10"></div>
                                        <div className="post_comment">
                                          {
                                            (childcomment.image != '') ?
                                              <img src={childcomment.image} className="commet-img"/>
                                            : null
                                          }
                                            <p>{childcomment.comment} </p>
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="post_comment_footer">
                                          <div id={`comment_toolbar_options_${childcomment.id}`} className="hidden" >
                                            <a href="#" id={`${comment.id}_${this.props.feed_id}_LIKE_${childcomment.id}`} ><img src={iconPath['LIKE']} /></a>
                                            <a href="#" id={`${comment.id}_${this.props.feed_id}_DISLIKE_${childcomment.id}`} ><img src={iconPath['DISLIKE']} /></a>
                                            <a href="#" id={`${comment.id}_${this.props.feed_id}_LAUGH_${childcomment.id}`} ><img src={iconPath['LAUGH']} /></a>
                                            <a href="#" id={`${comment.id}_${this.props.feed_id}_ANGRY_${childcomment.id}`} ><img src={iconPath['ANGRY']} /></a>
                                            <a href="#" id={`${comment.id}_${this.props.feed_id}_LOVE_${childcomment.id}`} ><img src={iconPath['LOVE']} /></a>
                                            <a href="#" id={`${comment.id}_${this.props.feed_id}_SAD_${childcomment.id}`} ><img src={iconPath['SAD']} /></a>
                                            <a href="#" id={`${comment.id}_${this.props.feed_id}_BREAK HEART_${childcomment.id}`} ><img src={iconPath['BREAKHEART']} /></a>
                                            <div className="clearfix"></div>
                                          </div>
                                            <div className="lile_count" id={`comment_element_${childcomment.id}`} onMouseEnter={() => this.openPopup(childcomment.id,childcomment.my_reaction)}>
                                              <p>{/* {languagelist.like} */}
                                                  <img width="35px" src= {(childcomment.my_reaction == '') ? "/assets/images/like_dislike_goldspace.png" : iconPath[childcomment.my_reaction]}></img> 
                                              </p>
                                            </div>
                                            {(childcomment.total_reaction > 0) ?
                                              <div className="like_icons">
                                                  <a  href={void(0)} onClick={()=>this.fetchLikeCommentList(childcomment.id,this.props.data_type)}>{childcomment.total_reaction} </a>
                                              </div>
                                              : null
                                            }
                                            <CommentLikeModal key={childcomment.id} handleClose={this.handleCloseComment} modalOpen={this.state.modal_open_comment} reactionList={this.state.commentreactionList}/>
                                        </div>
                                        <div className="clr20"></div>
                                    </div>
                                  </div>
                                  )
                                })
                              : null
                            }
                            <div className="make_a_cmnt" style={(this.state.open_comment_reply == comment.id) ? {display:'block'} : {display:'none'}}>
                              <input type="text" id="user_child_comment" name="user_child_comment" value={this.state.user_child_comment} placeholder="Type Comments Here..." onChange={this.handleChange}/>
                              <a href={void(0)} className="comment_send" onClick={()=> this.makeComment(this.props.data_type,this.props.feed_id,comment.id)}>
                                <i className="fa fa-paper-plane"></i>
                              </a>
                            </div>
                        </div>
                    </div>
                </li>
              )
            })
          : null 
        }
        </ul>
        <div className="make_a_cmnt" >
            <input type="text" id="user_comment" name="user_comment" value={this.state.user_comment} placeholder={languagelist.comment} onChange={this.handleChange}/>
            <a href={void(0)} className="comment_send" onClick={()=> this.makeComment(this.props.data_type,this.props.feed_id)}>
              <i className="fa fa-paper-plane"></i>
            </a>
        </div>
      </div>
      )
  }
}

  const mapStateToProps = state => {
    return {
      commentList           : state.fetchcommentlist.commentFeedList,
      updateComment         : state.updatecommentlist.commentFeedResponse,
      updatelikelist        : state.updatelikelist.likeFeedResponse,
      updatecommentlikelist : state.updatecommentlikelist.likeCommentResponse,
      commentlikelist       : state.fetchlikecommentlist.likeCommentList,
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      fetchCommentFeed       : bindActionCreators(fetchCommentFeed, dispatch),
      updateCommentFeed      : bindActionCreators(updateCommentFeed, dispatch),
      updateLikeComment      : bindActionCreators(updateLikeComment, dispatch), 
      fetchLikeComment       : bindActionCreators(fetchLikeComment, dispatch),
      fetchCommentMedia      : bindActionCreators(fetchCommentMedia, dispatch),
      updateCommentMedia     : bindActionCreators(updateCommentMedia, dispatch),
      updateLikeMediaComment : bindActionCreators(updateLikeMediaComment, dispatch),
      fetchLikeMediaComment  : bindActionCreators(fetchLikeMediaComment, dispatch),
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(FeedFooterCommentDetails);
